import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ResultData } from '@app/core/_common/model';
import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class VariantTypeService {
  url :string = environment.url;
  gettingRecords :boolean;

  private readonly _record = new BehaviorSubject<any>(<any>[]);
  public record$ = this._record.asObservable();

  constructor(
    private http :HttpClient,
    private translate :TranslateService,
  ) {
    this.get({});
  }

  get(params :any) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/variant-types`, { params: params })
      .subscribe((resp :any) => {
        this.gettingRecords = false;
        this._record.next(resp);
      });
  }

  create(data :any) :Observable<any> {
    return this.http.post(`${this.url}/variant-types`, data).pipe(
      tap((resp :any) => {
        if (resp && resp.id) {
          const records :any = this._record.getValue();
          records.splice(0, 0, resp);
          this._record.next(records);
        }
      }),
    );
  }

  update(variantId :number, data :any) :Observable<any> {
    return this.http.put(`${this.url}/variant-types/${variantId}`, data).pipe(
      tap((resp :any) => {
        if (resp && resp.id) {
          const records :any = this._record.getValue();
          const idx = records.findIndex((row :any) => row.id == resp.id);
          records.splice(idx, 1, resp);
          this._record.next(records);
        }
      }),
    );
  }

  delete(variantId :number) {
    return this.http.delete(`${this.url}/variant-types/${variantId}`).pipe(
      tap((resp :any) => {
        const records :any = this._record.getValue();
        const idx = records.findIndex((row :any) => row.id == variantId);
        records.splice(idx, 1);
        this._record.next(records);
      }),
    );
  }
}
